<template>

<!-- const formData = ref({ 
  fullname: '', id_card_number: '', place_of_birth: '', npwp: '', gender: '',
  id_card_validity_periode: '', birth_date: '', residential_address: '', province: '', city: '',
  postal_code: '', country: '', current_address: '', employee_type: '', annual_income: '', 
  relative_name: '', relative_phone_number: '', relative_relationship: '',
  bank_name: '', account_name: '', account_number: '', kyc_status: user.value.kyc_status, is_lifetime: false, dont_have_npwp: false
}) -->
  <form role="form" @submit.prevent="onSubmitForm()">
    <h6 class="mb-0">{{ titlePage }}</h6>
    <p class="mb-0 text-sm">{{ subtitlePage }}</p>
    <hr class="my-3 horizontal dark" />
    <div class="row">
      <div class="col-4">
        <div class="form-group">
          <label for="fullName" class="form-label">Full Name</label>
          <input id="fullName" type="text" class="form-control" v-model="record.fullname" disabled />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label for="label" class="form-label">Place Of Birth</label>
          <input id="label" type="text" class="form-control" v-model="record.place_of_birth" disabled />
        </div>
      </div>

      <div class="col-4">
        <div class="form-group">
          <label for="label" class="form-label">Gender</label>
          <input id="label" type="text" class="form-control" v-model="record.gender" disabled />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label for="label" class="form-label">Birth Date</label>
          <input id="label" type="text" class="form-control" :value="record.birth_date != null && record.birth_date != '0001-01-01T00:00:00Z' ? record.birth_date : ''" disabled />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label for="label" class="form-label">Residential Address</label>
          <textarea class="form-control" v-model="record.residential_address" disabled></textarea>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label for="label" class="form-label">Province</label>
          <input id="label" type="text" class="form-control" v-model="record.province" disabled />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label for="label" class="form-label">City</label>
          <input id="label" type="text" class="form-control" v-model="record.city" disabled />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label for="label" class="form-label">Postal Code</label>
          <input id="label" type="text" class="form-control" v-model="record.postal_code" disabled />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label for="label" class="form-label">Country</label>
          <input id="label" type="text" class="form-control" v-model="record.country" disabled />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label for="label" class="form-label">Current Address</label>
          <textarea class="form-control" v-model="record.current_address" disabled></textarea>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label for="label" class="form-label">Bank Name</label>
          <input id="label" type="text" class="form-control" v-model="record.bank_name" disabled />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label for="label" class="form-label">Bank Account Name</label>
          <input id="label" type="text" class="form-control" v-model="record.bank_account_name" disabled />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label for="label" class="form-label">Bank Account Number</label>
          <input id="label" type="text" class="form-control" v-model="record.bank_account_number" disabled />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
            <label for="label" class="form-label">Employee Type</label>
            <input id="label" type="text" class="form-control" v-model="record.employee_type" disabled />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label for="label" class="form-label">Annual Income</label>
          <input id="label" type="text" class="form-control" v-model="record.annual_income" disabled />
        </div>
      </div>
      <div class="col-4" v-if="false">
        <div class="form-group">
          <label for="label" class="form-label">Relative Name</label>
          <input id="label" type="text" class="form-control" v-model="record.relative_name" disabled />
        </div>    
      </div>

      <div class="col-4"  v-if="false">    
        <div class="form-group">
          <label for="label" class="form-label">Relative Phone Number</label>
          <input id="label" type="text" class="form-control" v-model="record.relative_phone_number" disabled />
        </div>
      </div>

      <div class="col-4" v-if="false">
        <div class="form-group" >
          <label for="label" class="form-label">Relative Relationship</label>
          <input id="label" type="text" class="form-control" v-model="record.relative_relationship" disabled />
        </div>
      </div>    
      
      <div class="col-4" v-if="false">
        <div class="form-group">
          <label for="label" class="form-label">ID Card Validity Periode</label>
          <input id="label" type="text" class="form-control" v-model="record.id_card_validity_period" disabled />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label for="label" class="form-label">ID Card Number ({{ record.id_card_type }})</label>
          <input id="label" type="text" class="form-control" v-model="record.id_card_number" disabled />
        </div>
        <a v-if="record.id_card_image" :href="record.id_card_image" type="button" class="btn btn-primary btn-sm" target="_blank">
          File Id Card Numbers
        </a>
      </div>
      <div class="col-4">
        <div class="form-group" v-if="record.is_having_npwp">
          <label for="label" class="form-label">NPWP ({{ record.npwp_type }})</label>
          <input id="label" type="text" class="form-control" v-model="record.npwp" disabled />
        </div>
        <div class="form-group" v-else>
          <label for="label" class="form-label">NPWP</label>
          <input id="label" type="text" class="form-control" value="-" disabled />
        </div>
        <a v-if="record.npwp_image" :href="record.npwp_image" type="button" class="btn btn-primary btn-sm" target="_blank">
          File Npwp
        </a>
      </div>
      <div class="col-4" v-if="!record.is_having_npwp">
        <div class="form-group">
          <label for="label" class="form-label">Reason for NPWP</label>
          <textarea class="form-control" v-if="record.no_npwp_reason" v-model="record.no_npwp_reason" disabled></textarea>
          <textarea class="form-control"  v-else disabled>-</textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="form-group">
          <label for="role" class="form-label">KYC Status</label>
          <select class="dataTable-selector form-select form-select-sm" v-model="record.kyc_status" >
            <option v-for="status in statuses" :value="status" :key="status" >{{ status }}</option>                        
          </select>
        </div>
      </div>
      <div class="col-4" v-if="record.kyc_status == 'rejected'">
        <div class="form-group">
          <label for="label" class="form-label">KYC Rejection Reason</label>
          <textarea class="form-control" v-model="record.kyc_rejection_reason"></textarea>
        </div>
      </div>
    </div>
    

    <div class="mt-4 d-flex justify-content-end">
    <a class="m-0 btn btn-light" @click.prevent="$emit('cancel')">
        Cancel
    </a>
   
    <button
        type="submit"
        name="button"
        class="m-0 btn bg-gradient-success ms-2"
        
    >
        {{ submitButtonName }}
    </button>
    </div>
  </form>

  <!-- Modal -->
  <!-- <div class="modal fade" id="idCardModal" tabindex="-1" aria-labelledby="idCardModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="idCardModalLabel">File Image Id Card Numbers</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="ratio ratio-1x1" v-if="record.id_card_image">
            <iframe v-bind:src="record.id_card_image" title="Id Card Numbers" allowfullscreen></iframe>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div> -->

  </template>
  <script>

  export default {
    data() {
      return {
        record: {},
        roles: [],
        statuses: ['pending', 'awaiting', 'approved', 'rejected']
      };
    },
    props: {
        titlePage: String,
        subtitlePage: String,
        submitButtonName: String,
        onSubmit: { type: Function },
        onUpdateActivation: { type: Function },
        toggleModal: { type: Function },
        recordProps: { type: Object }
    },
    watch: {
        recordProps: function (newVal, oldVal) { // watch it
        console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        this.record = newVal
        }
    },
    methods: {
      userActiveUser(value) {
        console.log(value)
        this.onUpdateActivation(value)
      },
      onSubmitForm() {
      const payload = {
        kyc_status: this.record.kyc_status,
        kyc_rejection_reason: this.record.kyc_rejection_reason
      }
        this.onSubmit(payload)
      },
    }
  }
  </script>
  